import { createFileRoute } from "@tanstack/react-router";
import { DienstLocatiePage, dienstLocatieHead } from "../components/DienstLocatiePage";
import { dakkapelDordrecht } from "../lib/dienst-locatie-content";

export const Route = createFileRoute("/dakkapel-dordrecht")({
  head: () => dienstLocatieHead(dakkapelDordrecht),
  component: () => <DienstLocatiePage content={dakkapelDordrecht} />,
});
